module.exports = __webpack_public_path__ + "static/media/to-icon.3da9ee4e.png";